import { render, staticRenderFns } from "./ModalProcessoNorma.vue?vue&type=template&id=5c2f3252&scoped=true"
import script from "./ModalProcessoNorma.vue?vue&type=script&lang=js"
export * from "./ModalProcessoNorma.vue?vue&type=script&lang=js"
import style0 from "./ModalProcessoNorma.vue?vue&type=style&index=0&id=5c2f3252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2f3252",
  null
  
)

export default component.exports